











































import { Component, Vue, Prop } from "vue-property-decorator";
import { gameList } from "@/req/gameManage";
import countTo from "vue-count-to";
@Component({
  components: { countTo },
})
export default class Home extends Vue {
  public navListActive: any = 0;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  public navList;
  public addNav(index) {
    this.navListActive = index;
    this.$emit("getBaseNav", index);
  }
}
